module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114124_86_157.9ce05fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114124_86_157.jpg
// module id = Mhwz
// module chunks = 0